export const turnOnArtBoardClipPath = (self) => {
  const art_board_clip_path_el = self._getArtBoardClipPathElThrowable();
  const working_layer_el = self._getWorkingLayerElThrowable();
  const id = art_board_clip_path_el.id;
  if (!id) {
    throw new Error(`art_board_clip_path_el 의 id 를 찾을 수 없습니다.`);
  }
  working_layer_el.setAttributeNS(null, "clip-path", `url(#${id})`);
};
